export const DEFAULT_FILTERING = [{field: 'effective_status', operator: 'IN', value: ['ACTIVE', 'PAUSED']}];
